export default __webpack_public_path__ + "31719e425606218ea44cca2c4dada8dd.png";